import { Injectable } from '@angular/core';

declare const THREE: any;

@Injectable()
export class ObjectControls {
  controls;
  controlSize = 15;

  constructor() {}

  buttons = [
    {
      name: 'rotateCounterClockwise',
      image: new THREE.TextureLoader().load(
        '../../assets/images/objectControls/rotateCounterClockwise.png'
      )
    },
    {
      name: 'delete',
      image: new THREE.TextureLoader().load('../../assets/images/objectControls/delete.png')
    },
    //{
    //    name: 'info',
    //    image: new THREE.TextureLoader().load("../../assets/images/objectControls/info.png")
    //},
    {
      name: 'clone',
      image: new THREE.TextureLoader().load('../../assets/images/objectControls/clone.png')
    },
    {
      name: 'rotateClockwise',
      image: new THREE.TextureLoader().load(
        '../../assets/images/objectControls/rotateClockwise.png'
      )
    }
  ];

  buildControl(button) {
    const geometry = new THREE.PlaneBufferGeometry(this.controlSize, this.controlSize);
    const material = new THREE.MeshBasicMaterial({
      map: button.image,
      depthTest: false,
      depthWrite: false,
      transparent: true
    });
    const plane = new THREE.Mesh(geometry, material);

    plane.position.y = this.controlSize / 2;
    plane.name = button.name;

    return plane;
  }

  buildControls() {
    let container = new THREE.Object3D(),
      control,
      controlsCount = this.buttons.length - 1,
      i = 0;

    for (; i < this.buttons.length; i++) {
      control = this.buildControl(this.buttons[i]);
      container.add(control);
    }

    container.name = 'objectControls';
    container.visible = false;

    return container;
  }

  build() {
    if (!this.controls) this.controls = this.buildControls();
    return this.controls;
  }

  getButton(ray) {
    if (this.controls) {
      const intersection = ray.intersectObjects(this.controls.children)[0];
      if (intersection && intersection.object.visible) return intersection.object.name;
    }
    return null;
  }

  setVisibility(bool) {
    if (this.controls) {
      this.controls.visible = bool;
    }
  }

  setButtonVisibility(button, bool) {
    if (this.controls) this.controls.getObjectByName(button).visible = bool;
  }

  setPosition(p) {
    if (this.controls) this.controls.position.copy(p);
  }

  isVisible() {
    return this.controls ? this.controls.visible : false;
  }

  update() {
    if (this.controls) {
      var i = 0,
        btns = this.controls.children,
        visible = btns.filter(function(b) {
          return b.visible;
        }),
        visibleCount = visible.length,
        hiddenCount = btns.length - visibleCount,
        offset = ((visibleCount - 1) / 2) * this.controlSize;

      for (; i < visibleCount; i++) {
        visible[i].position.x = this.controlSize * i - offset;
      }

      this.setVisibility(visibleCount !== 0);
    }
  }

  lookAtCamera(cameraPosition) {
    if (this.controls) this.controls.lookAt(cameraPosition);
  }

  setRotation(euler) {
    if (this.controls) this.controls.rotation.copy(euler);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/object-controls.service.ts